import { Addons } from '../types/enums';
export const SELECTED_PRODUCT = 'addon:selectedProduct_';

export const getAddonStorageKey = (organizationId: string, addon: Addons) =>
  `${SELECTED_PRODUCT}${organizationId}_${addon.split(' ').join('_')}`;
